/** Canonical employment types for posting, AI draft, and filters. */
export const EMPLOYMENT_TYPES = [
  "Full-time",
  "Part-time",
  "Contract",
  "Freelance",
  "Fractional",
  "Internship",
  "Co-founder",
] as const

export type EmploymentType = (typeof EMPLOYMENT_TYPES)[number]

/**
 * Types called out on public marketing doors. Subset of EMPLOYMENT_TYPES —
 * the distinctive mix Hire actually sells, not the full posting taxonomy.
 */
export const FEATURED_EMPLOYMENT_TYPES = [
  "Fractional",
  "Full-time",
  "Internship",
] as const satisfies readonly EmploymentType[]

/** Job work arrangement — keep labels in sync with seeker WORK_MODES. */
export const JOB_WORK_MODES = [
  { value: "onsite", label: "On-site" },
  { value: "hybrid", label: "Hybrid" },
  { value: "remote", label: "Remote" },
  { value: "flexible", label: "Flexible" },
] as const

export type JobWorkMode = (typeof JOB_WORK_MODES)[number]["value"]

export function jobWorkModeLabel(value: string | undefined) {
  return JOB_WORK_MODES.find((m) => m.value === value)?.label
}

/** Repair the legacy value — unpaid is compensation, not an employment type. */
export function normalizeEmploymentType(type: string) {
  return type === "Unpaid internship" ? "Internship" : type
}
